var map = {
	"./symbol_0.png": 38983,
	"./symbol_1.png": 63198,
	"./symbol_10.png": 83228,
	"./symbol_11.png": 19141,
	"./symbol_12.png": 7662,
	"./symbol_2.png": 99925,
	"./symbol_3.png": 88300,
	"./symbol_4.png": 37699,
	"./symbol_5.png": 31514,
	"./symbol_6.png": 7761,
	"./symbol_7.png": 59368,
	"./symbol_8.png": 22783,
	"./symbol_9.png": 68982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24066;